export const userSelect = (data) => ({
    isPasswordSet: data.IsPasswordSet,
    username: data.UserName,
    contactId: data.ContactId,
});
